export enum AdType {
  BANNER = 'BANNER',
  BLOCK = 'BLOCK',
}

export enum AdSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

export interface Ad {
  id: number;
  title: string;
  image: string;
  description: string;
  link: string;
  size: AdSize;
  type: AdType;
  buttonText?: string;
  advertiser?: string;
  advertiserInfo?: string;
}

export type ShowAdsByIds = Record<string, boolean>;

export interface WrapperAdsActions {
  hydrate: (fresh: Partial<WrapperAdsState>) => void;
  registerAdShowcase: (id: number | string) => void;
  afterShowCallback: (ad: Ad) => void;
  fetchAds: () => Promise<void>;
}

export interface WrapperAdsState {
  ads: Ad[];
  shownAds: ShowAdsByIds;
  actions: WrapperAdsActions;
}
